'use-strict';

import { ILocationService, IOnChangesObject } from 'angular';

/* @ngInject */
export default class CardController {
  private $location: ILocationService;

  public action?: string;

  public fn?: () => void;

  public hasAction = false;

  constructor(
    $location: ILocationService,
  ) {
    this.$location = $location;
  }

  /** Fix for upgrading this component from NG1 to NG2:
   * The `fn` binding is optional, but NG2 still passes data
   * to the component. Therefore we check every binding change,
   * if `fn` gets data bound to it or not.
   *
   * @reference https://stackoverflow.com/questions/66993691
   */
  public $onChanges(changes: IOnChangesObject): void {
    if (changes.fn) this.hasAction = true;
  }

  $onInit(): void {
    this.hasAction = this.hasAction || !!this.action;
  }

  public cardClick = (): void => {
    if (this.action) this.$location.url(this.action);
    if (this.fn) this.fn();
  };
}
